export default __webpack_public_path__ + "static/media/total earnings.8df90942.svg";